import React from "react";
import DangerSVG from "./icons/danger.svg";
import PortalRender from "@appComponents/PortalRender/PortalRender";

import * as style from "./RiskBannerStyle.module.scss"

const RiskBanner: React.FC = () => {
  if (process.env.UK_RISK_MODAL_ENABLED?.toLowerCase() !== "true") {
    return null;
  }

  return (
    <PortalRender portalId="risk-banner-container">
      <div className={style.riskBanner}>
        <span>
          Don't invest unless you're prepared to lose all the money you invest.
          This is a high-risk investment and you should not expect to be
          protected if something goes wrong.{" "}
          <a
            href="https://bnktothefuture.com/uk-risk-disclaimer/"
            target="_blank"
          >
            Take 2 mins to learn more.
          </a>
        </span>
      </div>
    </PortalRender>
  );
};

export default RiskBanner;
